export default __webpack_public_path__ + "static/media/trash.1b0b3292.svg";